<!-- 布局 -->
<template>
  <div class="layout-wrapper">
    <unlogin-header></unlogin-header>

    <!-- <cus-header></cus-header> -->
    <div class="main">
      <router-view></router-view>
    </div>
    <cus-footer></cus-footer>
  </div>
</template>

<script>
import cusHeader from "./common/header";
import cusFooter from "./common/footer";
import unloginHeader from "./common/unloginHeader.vue";

export default {
  data() {
    return {
      name: "",
    };
  },
  components: {
    cusHeader,
    cusFooter,
    unloginHeader,
  },
  created() {
    this.name = this.$route.name;
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.layout-wrapper {
  min-height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  .main {
    flex-grow: 1;
    position: relative;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/layout.vue